import { useQuery } from '@tanstack/react-query'
import { getAllTm } from '@/api/map/member'
import { keys } from '@/api/hooks/shared/keys'

/** Triple Masters visible to a Company Master (CM-API enforces caller role). */
export function useAllTm(enabled: boolean) {
  return useQuery({
    queryKey: keys.allTm,
    queryFn: () => getAllTm(),
    enabled,
    staleTime: 60_000,
  })
}
